import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Dashboard from "./pages/admin/Dashboard";
import GalleryAdmin from "./pages/admin/GalleryAdmin";
import VideoGalleryAdmin from "./pages/admin/VideoGalleryAdmin";
import TestimonialsAdmin from "./pages/admin/TestimonialsAdmin";
import WallOfFameAdmin from "./pages/admin/WallOfFameAdmin";
import MessagesAdmin from "./pages/admin/MessagesAdmin";
import SettingsAdmin from "./pages/admin/SettingsAdmin";
import MapAdmin from "./pages/admin/MapAdmin";
import ChatbotLeadsAdmin from "./pages/admin/ChatbotLeadsAdmin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Unsubscribe from "./pages/Unsubscribe";

const queryClient = new QueryClient();

const App = () => {
  return (

  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
    <ThemeProvider>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />}>
              <Route index element={<Dashboard />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="video-gallery" element={<VideoGalleryAdmin />} />
              <Route path="testimonials" element={<TestimonialsAdmin />} />
              <Route path="wall-of-fame" element={<WallOfFameAdmin />} />
              <Route path="messages" element={<MessagesAdmin />} />
              <Route path="chatbot-leads" element={<ChatbotLeadsAdmin />} />
              <Route path="map" element={<MapAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
    </ThemeProvider>
    </HelmetProvider>
  </QueryClientProvider>
  );
};

export default App;
